
import React from 'react';
import { Box, Container, Grid, Typography, Link, Divider } from '@mui/material';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import Badge from '@mui/icons-material/Badge';
import logo from "../Assets/logoWhite.svg";
import { LogoText } from './Navbar';

const Footer = React.forwardRef(({ homeRef, servicesRef, productsRef, clientsRef, teamRef }, ref) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleScroll = (ref) => {
    if (ref?.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleNavigation = (targetSection) => {
    if (location.pathname === '/') {
      handleScroll(targetSection);
    } else {
      navigate('/', { state: { scrollTo: targetSection } });
    }
  };

  return (
    <Box ref={ref} sx={{ bgcolor: '#17273F', color: '#FFF', p: 4, px: { xs: 1, sm: 4 } }}>
      <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'space-between', gap: 6, flexDirection: { xs: 'column', md: 'row' }, mb: 4 }}>
      <Box sx={{ mb: { xs: 2, sm: 0 }, maxWidth: '400px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <img src={logo} alt="Awura Logo" style={{ width: '90px', height: 'auto' }} />
        <Box sx={{ mt: 1, mb: 2 }}>
          <span
          className="logo-font"
          style={{
            color: "white",
            fontSize: "43px", 
            lineHeight: 1,
            display: "block"
          }}
          >
          AWURA
          </span>
          <Typography variant="body2" style={{ color: "white" }}>
          https://awura.tech
          </Typography>
        </Box>
        </Box>
        <Typography variant="body3" sx={{ mb: 2 }}>
        Leading technology solutions provider specializing in innovative software development and digital transformation services.
        </Typography>
        <Box sx={{ display: 'flex', my: 4 }}>
        <Link href="https://www.instagram.com/awura_et?igsh=MTI4eGl6dXlzMWlzaA==" color="inherit" sx={{ mx: 1 }}>
          <InstagramIcon />
        </Link>
        <Link href="https://www.facebook.com/profile.php?id=100092874956734&mibextid=ZbWKwL" color="inherit" sx={{ mx: 1 }}>
          <FacebookIcon />
        </Link>
        <Link href="https://www.linkedin.com/company/awura/" color="inherit" sx={{ mx: 1 }}>
          <LinkedInIcon />
        </Link>
        <Link
          href="https://maps.app.goo.gl/c7EDgcGTtCVHJSMg7"
          color="inherit"
          sx={{ mx: 1 }}
          target="_blank"
          rel="noopener noreferrer"
        >
          <LocationOnIcon />
        </Link>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', gap: { xs: 4, sm: 10 } }}>
        <Grid justifyContent="center">
        <Grid item mb={2}>
          <Typography variant="h6">
          Quick Links
          </Typography>
          <Divider sx={{ bgcolor: '#FFF', width: '110px' }} />
        </Grid>
        <Grid item mb={2}>
          <RouterLink
          to="/"
          style={{ color: 'inherit', textDecoration: 'none', fontSize: "16px" }}
          onClick={() => handleNavigation(homeRef)}
          >
         <Typography
    sx={{
      opacity: 0.75,
      transition: 'opacity 0.3s ease',
      '&:hover': {
        opacity: 1
      }
    }}
  >
    Home
  </Typography>
          </RouterLink>
        </Grid>
        <Grid item mb={2}>
          <RouterLink
          to="/"
          style={{ color: 'inherit', textDecoration: 'none', fontSize: "16px" }}
          onClick={() => handleNavigation(servicesRef)}
          >
         <Typography
    sx={{
      opacity: 0.75,
      transition: 'opacity 0.3s ease',
      '&:hover': {
        opacity: 1
      }
    }}
  >
    Services
  </Typography>
          </RouterLink>
        </Grid>
        <Grid item mb={2}>
          <RouterLink
          to="/"
          style={{ color: 'inherit', textDecoration: 'none', fontSize: "16px" }}
          onClick={() => handleNavigation(productsRef)}
          >
         <Typography
    sx={{
      opacity: 0.75,
      transition: 'opacity 0.3s ease',
      '&:hover': {
        opacity: 1
      }
    }}
  >
    Products
  </Typography>
          </RouterLink>
        </Grid>
        <Grid item mb={2}>
          <RouterLink
          to="/"
          style={{ color: 'inherit', textDecoration: 'none', fontSize: "16px" }}
          onClick={() => handleNavigation(teamRef)}
          >
         <Typography
    sx={{
      opacity: 0.75,
      transition: 'opacity 0.3s ease',
      '&:hover': {
        opacity: 1
      }
    }}
  >
    Our Team
  </Typography>
          </RouterLink>
        </Grid>
        <Grid item mb={2}>
          <RouterLink
          to="/"
          style={{ color: 'inherit', textDecoration: 'none', fontSize: "16px" }}
          onClick={() => handleNavigation(clientsRef)}
          >
         <Typography
    sx={{
      opacity: 0.75,
      transition: 'opacity 0.3s ease',
      '&:hover': {
        opacity: 1
      }
    }}
  >
    Clients
  </Typography>
          </RouterLink>
        </Grid>
        </Grid>

        <Box>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" style={{ color: "white" }}>
          Contact us
          </Typography>
          <Divider sx={{ bgcolor: '#FFF', width: '110px' }} />
        </Box>
        <Link href="https://maps.app.goo.gl/c7EDgcGTtCVHJSMg7" color="inherit" target="_blank" rel="noopener noreferrer" underline="none">
          <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
          <LocationOnIcon style={{ color: "white" }} />
          <Typography sx={{
        color: "white",
        fontSize: "16px",
        opacity: 0.75,
        transition: 'opacity 0.3s ease',
        '&:hover': {
          opacity: 1
        }
      }}>
            Rizq house building 5th floor, Gabon St, Addis Ababa
          </Typography>
          </Box>
        </Link>
        <Link href="tel:+251912062727" color="inherit" target="_blank" rel="noopener noreferrer" underline="none">
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 2 }}>
          <PhoneIcon style={{ color: "white" }} />
          <Box>
            <Link href="tel:+251912062727" color="inherit" underline="none">
            <Typography  sx={{
        color: "white",
        fontSize: "16px",
        opacity: 0.75,
        transition: 'opacity 0.3s ease',
        '&:hover': {
          opacity: 1
        }
      }}>+251912062727</Typography>
            </Link>
            <Link href="tel:+251910183505" color="inherit" underline="none">
            <Typography  sx={{
        color: "white",
        fontSize: "16px",
        opacity: 0.75,
        transition: 'opacity 0.3s ease',
        '&:hover': {
          opacity: 1
        }
      }}>+251910183505</Typography>
            </Link>
          </Box>
          </Box>
        </Link>
        <Link href="mailto:contact@awura.tech" color="inherit" target="_blank" rel="noopener noreferrer" underline="none">
          <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
          <EmailIcon style={{ color: "white" }} />
          <Typography  sx={{
        color: "white",
        fontSize: "16px",
        opacity: 0.75,
        transition: 'opacity 0.3s ease',
        '&:hover': {
          opacity: 1
        }
      }}>
            contact@awura.tech
          </Typography>
          </Box>
        </Link>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 2 }}>
          <Badge style={{ color: "white" }} />
          <Typography  sx={{
        color: "white",
        fontSize: "16px",
        opacity: 0.75,
        transition: 'opacity 0.3s ease',
        '&:hover': {
          opacity: 1
        }
      }}>
          Tin:0057344005
          </Typography>
        </Box>
        </Box>
      </Box>
      </Container>
      <Container
  maxWidth="lg"
  sx={{
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: 'center',
    mt: 4,
    pt: 2
  }}
>
  <Typography variant="body2" >
    © {new Date().getFullYear()} Awura Technologies. All rights reserved.
  </Typography>
</Container>

    </Box>
    );
});


export default Footer;